import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { HomePage } from "./pages/HomePage";
import { EquipmentPage } from "./pages/EquipmentPage";
import { SalesPage } from "./pages/SalesPage";
import { RentalPage } from "./pages/RentalPage";
import { MaintenancePage } from "./pages/MaintenancePage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { BlogPage } from "./pages/BlogPage";
import { RaioXPage } from "./pages/RaioXPage";
import { TomografiaPage } from "./pages/TomografiaPage";
import { RessonanciaPage } from "./pages/RessonanciaPage";
import { UltrassomPage } from "./pages/UltrassomPage";
import { DensitometriaPage } from "./pages/DensitometriaPage";
import { MamografiaPage } from "./pages/MamografiaPage";
import { CRPage } from "./pages/CRPage";
import { DRPage } from "./pages/DRPage";
import { WorkstationPage } from "./pages/WorkstationPage";
import { PACSPage } from "./pages/PACSPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/equipment" element={<EquipmentPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/rental" element={<RentalPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/raio-x" element={<RaioXPage />} />
          <Route path="/tomografia" element={<TomografiaPage />} />
          <Route path="/ressonancia" element={<RessonanciaPage />} />
          <Route path="/ultrassom" element={<UltrassomPage />} />
          <Route path="/densitometria" element={<DensitometriaPage />} />
          <Route path="/mamografia" element={<MamografiaPage />} />
          <Route path="/cr" element={<CRPage />} />
          <Route path="/dr" element={<DRPage />} />
          <Route path="/workstation" element={<WorkstationPage />} />
          <Route path="/pacs" element={<PACSPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
